import { render, staticRenderFns } from "./ZList1.vue?vue&type=template&id=5015209e&scoped=true"
import script from "./ZList1.vue?vue&type=script&lang=js"
export * from "./ZList1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5015209e",
  null
  
)

export default component.exports